export default __webpack_public_path__ + "static/media/right-column-bottom-right-image.88f80844.jpg";